import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosHttp from "services/axiosHttp";

export const printAllocationInvoice = createAsyncThunk(
    "tms/printAllocationInvoice",
    async (allocationId, { rejectWithValue }) => {
        try {
            const response = await axiosHttp.get(`tms/allocations/${allocationId}/invoice`, {
                responseType: 'blob'
            });
            
            // Create a blob URL and trigger download/open
            const file = new Blob([response.data], { type: 'application/pdf' });
            const fileURL = URL.createObjectURL(file);
            const link = document.createElement('a');
            link.href = fileURL;
            link.setAttribute('download', `invoice_allocation_${allocationId}.pdf`);
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
            URL.revokeObjectURL(fileURL);

            return { success: true };
        } catch (err) {
            if (!err.response) throw err;
            return rejectWithValue(err.response.data);
        }
    }
);

const AllocationInvoiceSlice = createSlice({
    name: "AllocationInvoiceSlice",
    initialState: {
        loading: false,
        error: null,
    },
    reducers: {
        resetAllocationInvoice: (state) => {
            state.loading = false;
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(printAllocationInvoice.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(printAllocationInvoice.fulfilled, (state) => {
            state.loading = false;
        });
        builder.addCase(printAllocationInvoice.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
    },
});

export const { resetAllocationInvoice } = AllocationInvoiceSlice.actions;
export default AllocationInvoiceSlice.reducer;
